/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IRealTimeRemoteDto } from "./i-real-time-remote-dto";
import { IRemoteDto } from "./i-remote-dto";
import { AssistanceState } from "./assistance-state";

export class UserAssistanceStateRealTimeData implements IRealTimeRemoteDto, IRemoteDto {
    userId: number;
    state: AssistanceState;
    assistingUserId: number;
}
